import { FAQState } from '../state/faqState';
import {
    Fetch_All_FAQ_LIST_Data, FAQ_Success,
    Fetch_FAQ_Request
} from '../action/faqAction';

export function FAQReducer(state = FAQState, action) {
    switch (action.type) {
        case Fetch_All_FAQ_LIST_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                FAQList : action.list,
                message : action.message,
                isLoading : action.isLoading
            })
        case FAQ_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                isLoading : action.isLoading
            })
        case Fetch_FAQ_Request:
            return Object.assign({}, state, {
                errorCode : 0,
                statusCode : 0,
                message : '',
                isLoading : action.isLoading
            })
        default:
            return state
    }
}